import {
  NEWS_ARTICLE_REQUEST,
  NEWS_ARTICLE_FAILURE,
  FETCH_NEWS_ARTICLES_SUCCESS,
  CREATE_NEWS_ARTICLE_SUCCESS,
  DELETE_NEWS_ARTICLE_SUCCESS,
  UPDATE_NEWS_ARTICLE_SUCCESS,
  GET_NEWS_ARTICLE_SUCCESS,
} from "../action/types";

const initialState = {
  articles: [], // Danh sách tin tức
  total: 0, // Tổng số bản ghi (pagination)
  currentArticle: null, // Tin bài hiện tại đang xem/sửa
  loading: false, // Trạng thái đang tải
  error: null, // Thông báo lỗi (nếu có)
};

const newsArticleReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case NEWS_ARTICLE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_NEWS_ARTICLES_SUCCESS:
      return {
        ...state,
        loading: false,
        articles: payload?.data ?? (Array.isArray(payload) ? payload : []),
        total: payload?.total ?? (Array.isArray(payload) ? payload.length : 0),
      };

    case GET_NEWS_ARTICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        currentArticle: payload,
        // Cập nhật lại trong list nếu đã có
        articles: state.articles.map((item) =>
          item.id === payload?.id ? payload : item,
        ),
      };

    case CREATE_NEWS_ARTICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        articles: [payload, ...state.articles],
        total: state.total + 1,
      };

    case UPDATE_NEWS_ARTICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        articles: state.articles.map((item) =>
          item.id === payload?.id ? payload : item,
        ),
      };

    case DELETE_NEWS_ARTICLE_SUCCESS:
      return {
        ...state,
        loading: false,
        articles: state.articles.filter((item) => item.id !== payload),
        total: state.total - 1,
      };

    case NEWS_ARTICLE_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return state;
  }
};

export default newsArticleReducer;
